import {createSlice} from '@reduxjs/toolkit';

export enum ToastActionType {
  CHAT = 'CHAT',
  FLIGHT = 'FLIGHT',
  AIRPORT = 'AIRPORT',
  OPS = 'OPS',
  ETL = 'ETL'
}

export interface IToast {
  id: number;
  visible: boolean;
  title: string;
  message: string;
  actionText: string;
  actionType: ToastActionType;
  entity: any;
  firebaseKey: string;
  thread?: string;
}

export interface ToastState {
  toasts: IToast[];
  currentIndex: number;
}

const initialState: ToastState = {
  toasts: [],
  currentIndex: 0
};

const toastSlice = createSlice({
  name: 'toastSlice',
  initialState,
  reducers: {
    addToast(state, action: {payload: Omit<IToast, 'id' | 'visible'>}) {
      if (!state.toasts) {
        state.toasts = [];
      }
      state.toasts.unshift({
        id: state.currentIndex,
        visible: true,
        ...action.payload
      });
      if (state.toasts.length > 3) {
        state.toasts.pop();
      }
      state.currentIndex += 1;
    },
    hideToast(state, action) {
      state.toasts = state.toasts.map((toast) => {
        if (toast.id === action.payload) {
          return {
            ...toast,
            visible: false
          };
        }
        return toast;
      });
    },
    removeToast(state, action) {
      state.toasts = state.toasts.filter(
        (toast) => toast.id !== action.payload
      );
    }
  }
});

export const {addToast, hideToast, removeToast} = toastSlice.actions;
export default toastSlice.reducer;
